import { ActionCreator } from 'redux';
import {
    templateTagListStartAction,
    templateTagListSuccessAction,
    templateTagListErrorAction,
    templateTagDeleteStartAction,
    templateTagDeleteSuccessAction,
    templateTagDeleteErrorAction,
} from './types';
import { TemplateTag, TagType } from '@dev/ee-api/ee-api-models';

export const templateTagListStart: ActionCreator<templateTagListStartAction> = (type: TagType): templateTagListStartAction => {
    return {
        type: '@@templateTagList/LOADING_START',
        payload: {
            type,
            loadingTemplatesTags: true,
        },
    };
};
export const templateTagListSuccess: ActionCreator<templateTagListSuccessAction> = (list: TemplateTag[]): templateTagListSuccessAction => ({
    type: '@@templateTagList/LOADING_SUCCESS',
    payload: {
        templatesTagsList: list,
        loadingTemplatesTags: false,
    },
});

export const templateTagListError: ActionCreator<templateTagListErrorAction> = (): templateTagListErrorAction => ({
    type: '@@templateTagList/LOADING_ERROR',
    payload: {
        loadingTemplatesTags: false,
    },
});

export const templateTagDeleteStart: ActionCreator<templateTagDeleteStartAction> = (name: string): templateTagDeleteStartAction => {
    return {
        type: '@@templateTagList/DELETE_START',
        payload: {
            name,
            type: TagType.Template,
            DeletingTemplatesTag: true,
        },
    };
};
export const templateTagDeleteSuccess: ActionCreator<templateTagDeleteSuccessAction> = (
    name: string,
    list: TemplateTag[]
): templateTagDeleteSuccessAction => ({
    type: '@@templateTagList/DELETE_SUCCESS',
    payload: {
        name,
        type: TagType.Template,
        templatesTagsList: list,
        DeletingTemplatesTag: false,
    },
});
export const templateTagDeleteError: ActionCreator<templateTagDeleteErrorAction> = (): templateTagDeleteErrorAction => ({
    type: '@@templateTagList/DELETE_ERROR',
    payload: {
        DeletingTemplatesTag: false,
    },
});
